export default __webpack_public_path__ + "static/Gilroy-SemiBold-017ff10cc8aae083265027dfa41e229a.otf";